"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require("./utils");

var _actions = require("egov-ui-framework/ui-redux/screen-configuration/actions");

var _actions2 = require("egov-ui-kit/redux/app/actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// pass the index
var FilePicker = function (_Component) {
  (0, _inherits3.default)(FilePicker, _Component);

  function FilePicker() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FilePicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FilePicker.__proto__ || Object.getPrototypeOf(FilePicker)).call.apply(_ref, [this].concat(args))), _this), _this.handleFileChange = function (event) {
      var input = event.target;
      var maxFiles = _this.props.inputProps.maxFiles;
      var _this$props = _this.props,
          toggleSnackbar = _this$props.toggleSnackbar,
          toggleSnackbarAndSetText = _this$props.toggleSnackbarAndSetText;

      if (input.files && input.files.length > 0) {
        var files = input.files;
        Object.keys(files).slice(0, maxFiles).forEach(function () {
          var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(key, index) {
            var file, valid, imageUri;
            return _regenerator2.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    file = files[key];
                    // check filename
                    // const extension = [".txt",
                    //                     ".php",
                    //                     ".exe",
                    //                     ".json"
                    //                     ];

                    valid = file.name.toLowerCase().indexOf(".txt") !== -1 || file.name.toLowerCase().indexOf(".php") !== -1 || file.name.toLowerCase().indexOf(".exe") !== -1 || file.name.toLowerCase().indexOf(".json") !== -1; //extension.includes(file.name);

                    if (!(file.size < 5242880)) {
                      _context.next = 18;
                      break;
                    }

                    if (valid) {
                      _context.next = 15;
                      break;
                    }

                    if (!file.type.match(/^image\//)) {
                      _context.next = 12;
                      break;
                    }

                    _context.next = 7;
                    return (0, _utils.getImageUrlByFile)(file);

                  case 7:
                    imageUri = _context.sent;

                    _this.props.handleimage(file, imageUri);
                    if (imageUri) {
                      //toggleSnackbarAndSetText(true, { labelName: "The file is not a valid image", labelKey: "CORE_COMMON_IMAGE_FILE_UPLOAD_SUCCESS" }, "success");
                    }
                    _context.next = 13;
                    break;

                  case 12:

                    toggleSnackbarAndSetText(true, { labelName: "The file is not a valid image", labelKey: "CORE_COMMON_INVALID_IMAGE_FILE" }, "warning");

                  case 13:
                    _context.next = 16;
                    break;

                  case 15:

                    toggleSnackbarAndSetText(true, { labelName: "Please select valid file!", labelKey: "CORE_COMMON_INVALID_FILE_EXTENSION" }, "warning");

                  case 16:
                    _context.next = 19;
                    break;

                  case 18:
                    toggleSnackbarAndSetText(true, { labelName: "The file is more than 5mb", labelKey: "ERR_FILE_MORE_THAN_FIVEMB" }, "warning");

                  case 19:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, _this2);
          }));

          return function (_x, _x2) {
            return _ref2.apply(this, arguments);
          };
        }());
      }
    }, _this.openFileDialog = function () {
      _this.upload.click();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FilePicker, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          inputProps = _props.inputProps,
          children = _props.children,
          id = _props.id,
          className = _props.className;
      var multiple = inputProps.multiple,
          accept = inputProps.accept;
      var handleFileChange = this.handleFileChange,
          openFileDialog = this.openFileDialog;

      return _react2.default.createElement(
        "div",
        { onClick: openFileDialog, className: className },
        _react2.default.createElement("input", {
          id: id,
          type: "file",
          multiple: multiple,
          accept: accept,
          ref: function ref(_ref3) {
            return _this3.upload = _ref3;
          },
          style: { display: "none" },
          onChange: handleFileChange
        }),
        children
      );
    }
  }]);
  return FilePicker;
}(_react.Component);

FilePicker.propTypes = {
  "inputProps.accept": _propTypes2.default.string,
  "inputProps.id": _propTypes2.default.string,
  "inputProps.multiple": _propTypes2.default.bool,
  "labelProps.icon": _propTypes2.default.node
};
var mapStateToProps = function mapStateToProps(state) {
  var screenConfiguration = state.screenConfiguration;
  var preparedFinalObject = screenConfiguration.preparedFinalObject;

  return { preparedFinalObject: preparedFinalObject };
};
var mapDispacthToProps = function mapDispacthToProps(dispatch) {
  return {
    toggleSnackbarAndSetText: function toggleSnackbarAndSetText(open, message, error) {
      return dispatch((0, _actions2.toggleSnackbarAndSetText)(open, message, error));
    },
    prepareFinalObject: function prepareFinalObject(path, value) {
      return dispatch((0, _actions.prepareFinalObject)(path, value));
    },
    toggleSnackbar: function toggleSnackbar(open, message, variant) {
      return dispatch((0, _actions.toggleSnackbar)(open, message, variant));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispacthToProps)(FilePicker);

// export default FilePicker;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/components/FilePicker/index.js
// module id = 1426
// module chunks = 895